import {usePunishmentTemplateQuery} from "@/api/punishmentApi";
import TemplateForm from "@/components/Common/forms/TemplateForm";
import {useInViewWithQuery} from "@/hooks/useInViewWithQuery";
import {
  disciplinaryModalAtom,
  disciplineCustomContentAtom,
  disciplineTemplateFormAtom,
  templateLanguageAtom,
} from "@/store/jotaiAtoms";
import type {TPunishmentType} from "@/store/types";
import {useAtomValue, useSetAtom} from "jotai";
import {useEffect, type FC} from "react";
import {useTranslation} from "react-i18next";

const DisciplineTemplateForm: FC<{
  hideFormConfig?: boolean;
  isDisabled?: boolean;
  selectedPunishmentType: TPunishmentType;
  showCustomContent?: boolean;
}> = ({hideFormConfig, isDisabled, selectedPunishmentType, showCustomContent}) => {
  const {t} = useTranslation("influencer_discipline");
  const templatesQuery = usePunishmentTemplateQuery(selectedPunishmentType);
  const disciplinaryData = useAtomValue(disciplinaryModalAtom);
  const setTemplate = useSetAtom(disciplineTemplateFormAtom);
  const templateLanguage = useAtomValue(templateLanguageAtom);

  const {ref: templatesQueryRef} = useInViewWithQuery(templatesQuery);

  const {selectedDiscipline} = disciplinaryData;

  useEffect(() => {
    if (!selectedDiscipline) {
      const otherTemplate = templatesQuery.data?.[0];

      setTemplate(otherTemplate!);
    } else {
      setTemplate(draft => {
        draft.translations.map(t => {
          if (t.language_code === "de_CH") {
            t.body = disciplinaryData.selectedDiscipline?.body_de ?? "";
            t.title = disciplinaryData.selectedDiscipline?.title_de ?? "";
          } else {
            t.body = disciplinaryData.selectedDiscipline?.body_en ?? "";
            t.title = disciplinaryData.selectedDiscipline?.title_en ?? "";
          }
        });
        draft.translations.find(t => t.language_code === templateLanguage);
      });
    }
  }, [selectedDiscipline, selectedPunishmentType, setTemplate, templatesQuery.data]);

  return (
    <TemplateForm
      contentId={selectedDiscipline?.id}
      customContentAtom={disciplineCustomContentAtom}
      data={templatesQuery.data?.map(template => ({...template, active: true}))}
      descriptionPlaceholder={t("description_placeholder")}
      hideFormConfig={hideFormConfig}
      isDisabled={isDisabled}
      isFetching={templatesQuery.isFetching}
      queryRef={templatesQueryRef}
      showCustomContent={showCustomContent}
      subjectPlaceholder={t("subject_placeholder")}
      templateFormAtom={disciplineTemplateFormAtom}
    />
  );
};

export default DisciplineTemplateForm;
